import { render, staticRenderFns } from "./PageDesc.vue?vue&type=template&id=31d2d78f"
import script from "./PageDesc.vue?vue&type=script&lang=js"
export * from "./PageDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports